/**
 * A dex number as trainers write it: "#007", "#150", "#1008" (2026-09-30
 * owner ask). Three digits, zero padded, until the dex reaches four digits.
 * Display only: the scanner's OCR reads Pokémon GO's own "#0007" format and
 * keeps its 4-digit handling.
 */
export function dexNumberLabel(n: number): string {
  return `#${String(Math.max(0, Math.trunc(n))).padStart(3, "0")}`;
}
